import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'ctv-forbidden',
    template: `Forbidden`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ForbiddenComponent {

  constructor() {
  }


}
